import script from "./ExtinguisherVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtinguisherVue.vue?vue&type=script&setup=true&lang=js"

import "./ExtinguisherVue.vue?vue&type=style&index=0&id=28c914a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c914a3"]])

export default __exports__